import { z } from "zod";
import { avatarColorSchema, languageSchema } from "../schemas";

export const userSettingsSchema = z.object({
  name: z.string().min(1),
  color: avatarColorSchema,
  language: languageSchema,
});
export type UserSettingsType = z.infer<typeof userSettingsSchema>;
